import { render, staticRenderFns } from "./RetailersList.vue?vue&type=template&id=7088057c&scoped=true&"
import script from "./RetailersList.vue?vue&type=script&lang=js&"
export * from "./RetailersList.vue?vue&type=script&lang=js&"
import style0 from "./RetailersList.vue?vue&type=style&index=0&id=7088057c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088057c",
  null
  
)

export default component.exports